const preventChangeQty = () => {
    document.querySelectorAll(".hs-price-total").forEach((priceEl) => {
        const priceText = priceEl.textContent.trim().toLowerCase();

        if (priceText === "free") {
            
            const itemContainer = priceEl.closest(".hs-content-quantity-price");

            if (itemContainer) {
                const incButton = itemContainer.querySelector(".hs-inc");
                const decButton = itemContainer.querySelector(".hs-dec");
                const inputField = itemContainer.querySelector("input");
                if (incButton) {
                    incButton.disabled = true;
                    incButton.style.opacity = "0.5";
                    incButton.style.cursor = "not-allowed";
                }
                if(decButton) {
                    decButton.disabled = true;
                    decButton.style.opacity = "0.5";
                    decButton.style.cursor = "not-allowed";
                }
                if (inputField) {
                    inputField.disabled = true;
                    inputField.style.opacity = "0.5";
                    inputField.style.cursor = "not-allowed";
                }
            }
        }
    });
}

const observer = new MutationObserver(() => {
  preventChangeQty();
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", preventChangeQty);